import { render, staticRenderFns } from "./ProductPageSkeleton.vue?vue&type=template&id=f251a726&scoped=true"
import script from "./ProductPageSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductPageSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f251a726",
  null
  
)

export default component.exports